import React, { useState } from 'react';
import { useAuth } from '../api/services/auth';
import { useInput } from '../hooks/useInput';
import { HalfCircleSpinner } from 'react-epic-spinners';
import ForgotPasswordForm from "./forgotPassowordForm";
import { toast } from 'react-toastify';

const LoginForm = ({ showForgotPasswordForm, setShowForgotPasswordForm }) => {
    const [username, bindUsername, resetUsername] = useInput("");
    const [password, bindPassword, resetPassword] = useInput("");
    const [errors, setErrors] = useState({});
    const { login, LoginError, showLoader, setShowLoader } = useAuth();
    const [showPass, setShowPass] = useState(false);

    // Check_Validation_Function
    const validateLogin = () => {
        let errors = {};
        let isValid = true;
        if (!username) {
            isValid = false;
            errors['username'] = 'Please enter your Username.';
            toast.error('Please enter your Username.');
        }
        if (!password) {
            isValid = false;
            errors['password'] = 'Please enter your Password.';
            toast.error('Please enter your Password.');
        }
        setErrors(errors);
        return isValid;
    };

    // Handle_Show_Password
    const handleShowPass = () => {
        setShowPass(!showPass);
    }

    const loginHandler = async (event) => {
        event.preventDefault();
        if (validateLogin()) {
            try {
                await login(username, password); // Assuming `login` is an async function.
                const urlState = { username, password };
                window.history.pushState(urlState, "", window.location.href);
            } catch (error) {
                setShowLoader(false)
                if (error && error.status === 401) {
                    toast.error(error?.data?.message ?? "Invalid username or password.");
                } else {
                    toast.error(error?.data?.message ?? "Something went wrong. Please try again later.");
                }
            }
        }
    };


    return (
        <>
            {!showForgotPasswordForm && (
                <form className={`loginForm ${showLoader && 'formDisable'}`} onSubmit={(event) => loginHandler(event)}>
                    <div className="formRow">
                        <div className="inputWrap">
                            <input
                                type="text"
                                className={`formControl ${errors.username && 'error'}`}
                                placeholder="Username"
                                {...bindUsername}
                            />
                        </div>
                    </div>
                    <div className="formRow">
                        <div
                            className={`inputWrap posRelative passWrap ${showPass && 'view'}`}
                        >
                            <input
                                type={showPass ? 'text' : 'password'}
                                className={`formControl ${errors.password && 'error'}`}
                                placeholder="Password"
                                id="passwordInput"
                                {...bindPassword}
                            />
                            <button
                                type='button'
                                className={`icnView fa-solid posAbsolute ${showPass ? 'fa-eye-slash' : 'fa-eye'}`}
                                onClick={() => {
                                    handleShowPass()
                                }}
                            ></button>
                        </div>
                    </div>
                    <div className="formBtnRow textCenter fontSmall">
                        <button
                            type="submit"
                            className="btn btnPrimary dBlock w100"
                            disabled={showLoader}
                        >Login
                            {showLoader && (
                                <HalfCircleSpinner
                                    size={18}
                                    style={{
                                        display: "inline-block",
                                        marginLeft: "7px",
                                        position: 'relative',
                                        top: '2px',
                                    }}
                                />
                            )}
                        </button>
                        <button
                            type='button'
                            className='btnLink'
                            onClick={() => {
                                setErrors('')
                                resetUsername()
                                resetPassword()
                                setShowForgotPasswordForm(true)
                            }}
                        >Forgot Password?</button>
                    </div>
                    {LoginError && (
                        <div className="formContainerError">{LoginError}</div>
                    )}
                </form>
            )}
            {showForgotPasswordForm && (
                <ForgotPasswordForm
                    setShowForgotPasswordForm={setShowForgotPasswordForm}
                />
            )}
        </>
    );
}

export default LoginForm;